import z from 'zod';
import { anyGeometry, pointGeometry, locale, customerRef, userRef, scopedEntity, AlarmSeverity, AlarmType, string, uuid, datetime, procedureString, } from '../common';
import { ZoneType } from './zone';
import { staticResponderRelation } from './staticResponder';
import { observationTrigger } from './observationTrigger';
import { observation } from './observation';
import { asset } from './asset';
import { namedCustomerRef } from './customer';
export var ResponderInfoRef;
(function (ResponderInfoRef) {
    ResponderInfoRef["Asset"] = "Asset";
    ResponderInfoRef["StaticResponder"] = "StaticResponder";
})(ResponderInfoRef || (ResponderInfoRef = {}));
export var ResponseGroupType;
(function (ResponseGroupType) {
    ResponseGroupType["Nearby"] = "nearby";
    ResponseGroupType["Personal"] = "personal";
    ResponseGroupType["Zone"] = "zone";
    ResponseGroupType["Police"] = "police";
    ResponseGroupType["AlarmProfessionalResponder"] = "alarmProfessionalResponder";
})(ResponseGroupType || (ResponseGroupType = {}));
export const responseZone = z.object({
    _id: uuid,
    customer: customerRef.optional(),
    type: z.nativeEnum(ZoneType).optional(),
    location: anyGeometry,
    name: string,
    staticResponders: staticResponderRelation.array(),
});
export const responderInfo = z.object({
    _id: uuid,
    _ref: z.nativeEnum(ResponderInfoRef),
    name: string,
    image: string.nullable(),
    position: pointGeometry.nullable(),
    locale: locale.nullable(),
    contactCode: string.nullable(),
});
export const responderActions = z.object({
    call: string.nullable(),
    sms: string.nullable(),
    email: string.nullable(),
    notification: z.boolean(),
});
export const responder = z.object({
    info: responderInfo,
    distanceKm: z.number().nullable(),
    actions: responderActions,
    priority: z.number(),
    availableAsAlarmProfessionalResponder: z.boolean().optional(),
});
export const responseGroup = z.object({
    type: z.nativeEnum(ResponseGroupType),
    priority: z.number(),
    zone: responseZone.optional(),
    responders: responder.array(),
});
const namedUserRef = z.object({
    ...userRef.shape,
    name: string,
});
export const alarmAcknowledgement = z.object({
    needed: z.boolean(),
    value: z.boolean(),
    ackedBy: namedUserRef.nullable(),
    comment: string.nullable(),
    ackedAt: datetime.nullable(),
});
export const alarmMetadataFrozenInfo = z.object({
    staticResponse: responseGroup.array(),
    dynamicResponse: responseGroup.array(),
});
export const alarmMetadata = z.object({
    observationTrigger: observationTrigger.optional(),
    observation: observation.optional(),
    frozenInfo: alarmMetadataFrozenInfo.optional(),
});
export const mergedAlarm = z.object({
    _id: uuid,
    name: string,
    createdAt: datetime,
    position: pointGeometry,
    meta: alarmMetadata.optional(),
});
export const alarm = z.object({
    ...scopedEntity.shape,
    customer: namedCustomerRef,
    name: string,
    type: z.nativeEnum(AlarmType),
    asset,
    ack: alarmAcknowledgement,
    position: pointGeometry.nullable(),
    severity: z.nativeEnum(AlarmSeverity),
    procedure: procedureString,
    meta: alarmMetadata.optional(),
    alarmCenter: namedCustomerRef.nullable(),
    lastMergedAt: datetime.optional(),
    lastPublishedToStreamAt: datetime.optional(),
    mergeHistory: mergedAlarm.array().optional(),
});
